<template lang="html">
  <div v-if="survey[$route.params.survey]">
    <div class="teaser">
      <div class="teaser-col-2">
        <div class="teaser-col teaser-col-img" :style="{backgroundImage:'url('+getTeaser()[1]+')'}">
          <svg class="teaser-mask" width="255px" height="366px" viewBox="0 0 255 366" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="overlay-new" fill="#FFFFFF">
                      <path d="M151.284,0 L255,0 L255,366 L0,366 L247.62,126.376 L247.852,126.147 C255.981,118.031 255.99,104.861 247.873,96.732 L151.284,0 Z" id="Shape"></path>
                  </g>
              </g>
          </svg>
        </div>
        <div class="teaser-col">
          <div v-html="getTeaser()[0]">
          </div>
          <router-link :to="'/survey/'+getTeaser()[3]" class="btn btn-dark" v-html="getTeaser()[2]">

          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import Marked from 'marked';
export default {
  name: 'Teaser',
  computed: {
      ...mapGetters([
        'survey'
      ])
  },
  methods: {
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    getTeaser(){
      let s = Number(this.$route.params.survey) + 1;
      let sL = Number(this.survey.length);
      let newS;
      if(s < sL){
        newS = s
      }else{
        newS = 0
      }
      return [this.compiledMarkdown(this.survey[newS].content4), this.survey[newS].topbillede1, this.survey[newS].content4knap, newS]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/modular/teaser.vue